import { Routes, Route, Navigate } from 'react-router-dom'
import { GuestGuard, AppGuard, RegistrationGuard, UserGuard } from '@/common/entities/me/lib/guards'
import { NavigationStackGuard } from '@/common/entities/navigationHistory'

import NotFoundPage from '@/app/pages/NotFoundPage'
import ServerUnavailablePage from '@/app/pages/ServerUnavailablePage'
import { LoginPage, ResetPasswordPage, RegistrationPage, VerifyEmailPage, RecoveryPage } from '@/app/pages/auth'
import { ROUTES } from './routes'
import {
    UserProfilePage,
    PaymentHistoryPage,
    OrgProfilePage,
    PaymentPage,
    LegalPage,
    IntegrationsPage,
    SupportPage,
} from '@/app/pages/profile'
import { ProductsLayout } from '@/app/layout/productsLayout'
import { ProductLayout } from '@/app/layout/productLayout'

import { ProfileLayout } from '@/app/layout/profileLayout/profileLayout'
import { AppLayout } from '@/app/layout/appLayout/appLayout'
import { Invitation } from '@/app/pages/Invitation'
import { Products } from '@/app/pages/Products'
import { StatsComparePage, StatsDetailedPage, StatsLayout, StatsSummaryPage } from '@/app/pages/Stats'
import { AnalyticsPage, TextsPage, MediaPage } from '@/app/entities/product/ui/'
import { Landing } from '@/landing/pages/Landing'

export const Routing = () => {
    return (
        <Routes>
            <Route path='/' element={<Landing />} />
            <Route path={ROUTES.AUTH.VERIFY_EMAIL} element={<VerifyEmailPage />} />
            <Route path={ROUTES.AUTH.RESET_PASSWORD} element={<ResetPasswordPage />} />
            <Route path={ROUTES.SERVER_UNAVAILABLE} element={<ServerUnavailablePage />} />
            <Route path='/app/invitations' element={<Invitation />} />
            <Route
                path={`${ROUTES.AUTH.BASE}/*`}
                element={
                    <GuestGuard throwOutTo={ROUTES.APP}>
                        <Routes>
                            <Route element={<AppGuard />}>
                                <Route element={<RegistrationGuard />}>
                                    <Route path='registration' element={<RegistrationPage />} />
                                </Route>
                            </Route>
                            <Route path='login' element={<LoginPage />} />
                            <Route path='recovery' element={<RecoveryPage />} />

                            <Route path='*' element={<Navigate to={ROUTES.AUTH.BASE} replace />} />

                            <Route path='*' element={<NotFoundPage />} />
                        </Routes>
                    </GuestGuard>
                }
            />
            <Route path={ROUTES.AUTH.BASE} element={<NotFoundPage />} />
            <Route
                path='/app/*'
                element={
                    <UserGuard throwOutTo={ROUTES.AUTH.LOGIN}>
                        <Routes>
                            <Route element={<NavigationStackGuard />}>
                                <Route path='profile' element={<ProfileLayout />}>
                                    <Route index element={<Navigate to='/app/profile/user' replace />} />
                                    <Route path='user' element={<UserProfilePage />} />
                                    <Route path='org' element={<OrgProfilePage />} />
                                    <Route path='payment' element={<PaymentPage />} />
                                    <Route path='payment-history' element={<PaymentHistoryPage />} />
                                    <Route path='legal' element={<LegalPage />} />
                                    <Route path='integrations' element={<IntegrationsPage />} />
                                    <Route path='support' element={<SupportPage />} />
                                </Route>

                                <Route path='/' element={<AppLayout />}>
                                    <Route path='products' element={<ProductsLayout />}>
                                        <Route index element={<Products />} />
                                        <Route path=':productId' element={<ProductLayout />}>
                                            <Route index element={<Navigate to='analytics' replace />} />
                                            <Route path='analytics' element={<AnalyticsPage />} />
                                            <Route path='texts' element={<TextsPage />} />
                                            <Route path='media' element={<MediaPage />} />
                                        </Route>
                                    </Route>
                                    <Route path='stats' element={<StatsLayout />}>
                                        <Route index element={<StatsSummaryPage />} />
                                        <Route path='compare' element={<StatsComparePage />} />
                                        <Route path='detailed' element={<StatsDetailedPage />} />
                                    </Route>
                                    <Route index element={<Navigate to='products' replace />} />
                                </Route>

                                <Route path='*' element={<NotFoundPage />} />
                            </Route>
                        </Routes>
                    </UserGuard>
                }
            />
            <Route path='*' element={<NotFoundPage />} />
        </Routes>
    )
}
